export default __webpack_public_path__ + "static/media/LOGOS3.e2e5721f.jpg";